// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalUiSemantics = {
  uiSemanticsTitle: "UI セマンティクス総覧",
  uiSemanticsSubtitle: "共通 Admin 操作のセマンティクス、アイコン、色マッピングを確認します。",
  uiSemanticsNotice:
    "同じ操作意図は同じ semantic key を再利用し、アイコンと token 色の一貫性を保ってください。",
  uiSemanticsTableTitle: "セマンティクスマッピング",
  uiSemanticsColumnSemantic: "セマンティクス",
  uiSemanticsColumnChineseLabel: "中国語ラベル",
  uiSemanticsColumnIcon: "アイコン",
  uiSemanticsColumnColor: "カラー token",
  uiSemanticsPreviewTitle: "AdminRowActions プレビュー",
  uiSemanticsLegendTitle: "Legend セマンティクスマッピング",
  uiSemanticsLegendColumnSemantic: "Legend Semantic",
  uiSemanticsLegendColumnDefaultLabel: "既定ラベル",
  uiSemanticsLegendColumnBadge: "Badge",
  uiSemanticsLegendColumnColor: "標準カラー token",
  uiSemanticsLegendUndefined: "未定義の legend semantic: {value}",
} as const;
